/**
 * LyndaKids Canonical Product Card Swatch System
 * Handles immediate synchronous color selection, label update, image swapping, and PDP link synchronization.
 */
(function() {
  if (typeof window === 'undefined') return;
  if (window.__lkfCardSwatchesInitialized) return;
  window.__lkfCardSwatchesInitialized = true;

  const imageCache = Object.create(null);

  function activateSwatch(btn) {
    if (!btn) return;

    const container = btn.closest('.lkf-card-swatches-system');
    if (!container) return;

    // 1. Synchronously update active states
    const siblings = container.querySelectorAll('.lkf-card-swatch-btn');
    siblings.forEach(s => {
      s.classList.remove('is-selected');
      s.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('is-selected');
    btn.setAttribute('aria-pressed', 'true');

    // 2. Synchronously update customer-facing color label
    const colorName = btn.getAttribute('data-color-name');
    const labelEl = container.querySelector('.lkf-swatch-current-name');
    if (labelEl && colorName) {
      labelEl.textContent = colorName;
    }

    // 3. Find card ancestor
    const card = btn.closest(
      '.lkf-ai-card, .lkf-cb-card, .product-block, .cc-product-block, .lkf-ur-card, .lkf-pr-card, .lkf-series-card, [data-product-card]'
    );
    if (!card) return;

    // 4. Synchronously swap card image
    const newImgSrc = btn.getAttribute('data-img-src');
    if (newImgSrc) {
      const mainImg = card.querySelector(
        '[data-main-img], .lkf-ai-card-img, .lkf-cb-card-img, .image__first img, .product-block__image img, img.lkf-ur-card-img, img.lkf-pr-card-img, img.lkf-series-card-img'
      );
      if (mainImg) {
        mainImg.src = newImgSrc;
        if (mainImg.hasAttribute('srcset')) {
          mainImg.setAttribute('srcset', newImgSrc);
        }
        const picture = mainImg.closest('picture');
        if (picture) {
          picture.querySelectorAll('source[srcset]').forEach(source => {
            source.setAttribute('srcset', newImgSrc);
          });
        }
        const srcLower = newImgSrc.toLowerCase();
        const isCover = srcLower.includes('sahne') || srcLower.includes('scene') || srcLower.includes('lifestyle');
        const stage = mainImg.closest('.lkf-cb-card-img-stage, .lkf-ai-card-img-stage');
        if (stage) {
          if (isCover) {
            stage.classList.add('is-cover');
            stage.classList.remove('is-contain');
            mainImg.classList.add('is-cover');
            mainImg.classList.remove('is-contain');
          } else {
            stage.classList.add('is-contain');
            stage.classList.remove('is-cover');
            mainImg.classList.add('is-contain');
            mainImg.classList.remove('is-cover');
          }
        }
      }
    }

    // 5. Update card links to the selected variant URL
    const variantUrl = btn.getAttribute('data-variant-url');
    if (variantUrl) {
      const cardLinks = card.querySelectorAll(
        '[data-card-link], .product-block__image a, .caption.upper, .lkf-ai-card-title a, .lkf-cb-card-title a, .lkf-ur-card-title a, .lkf-pr-card-title a, .lkf-series-card-title a'
      );
      cardLinks.forEach(link => {
        link.setAttribute('href', variantUrl);
      });
    }

    // 6. Synchronously update card pricing if provided
    const newPriceFormatted = btn.getAttribute('data-price-formatted');
    if (newPriceFormatted) {
      const priceEl = card.querySelector(
        '.lkf-ai-card-price, .lkf-cb-card-price, .price .theme-money, .product-block__price .theme-money'
      );
      if (priceEl) {
        priceEl.innerHTML = newPriceFormatted;
      }
      const newCompareFormatted = btn.getAttribute('data-compare-price-formatted');
      const wasPriceEl = card.querySelector(
        '.lkf-ai-card-was-price, .lkf-cb-card-was-price, .was-price'
      );
      if (wasPriceEl) {
        if (newCompareFormatted) {
          wasPriceEl.innerHTML = newCompareFormatted;
          wasPriceEl.style.display = '';
        } else {
          wasPriceEl.style.display = 'none';
        }
      }
    }
  }

  // Handle click / tap on swatches (prevent page navigation or card link stealing)
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.lkf-card-swatch-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    activateSwatch(btn);
  }, false);

  // Pre-warm variant images on hover on desktop
  document.addEventListener('mouseover', function(e) {
    const btn = e.target.closest('.lkf-card-swatch-btn');
    if (!btn) return;

    const imgSrc = btn.getAttribute('data-img-src');
    if (imgSrc && !imageCache[imgSrc]) {
      const img = new Image();
      img.src = imgSrc;
      imageCache[imgSrc] = true;
    }
  }, { passive: true });
})();
